/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { UserData } from '../@core/interfaces/common/users';

@Injectable()
export class AuthGuard implements CanActivate {
  protected readonly unsubscribe$ = new Subject<void>();
  routerEvents: any;
  currentUrl: string;
  studentTab = '';
  adminTab = '';
  constructor(private authService: NbAuthService,
    private userService: UserData,
    private router: Router,
    private usersService: UserData) {
    this.routerEvents = this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          var split = event.url.split('/');
          this.currentUrl = split[2];
        }
      }
    )
  }
  data: any;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.studentTab = 'studentDashboard,paidApplication,studentApplication,viewApplication,myApplications,FirstCancel,FirstFailure,PaymentSuccess,help,profile,contact-us,faq';
    this.adminTab = 'dashboard,PendingApplication,SignedApplication,SentApplication,RoleManagement,StudentManagement,TotalApplied,Payments,StudentFeedback,Reports,help,profile,contact-us,faq'
    let type = route.data["type"] as Array<string>

    return this.authService.isAuthenticated()
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            this.router.navigate(['auth/login']);
          } else {
            this.usersService.getCurrentUser().pipe(takeUntil(this.unsubscribe$))
              .subscribe(async (user) => {
                if (user.user_type == 'admin' && user.otp) {
                  if (this.adminTab.includes(type[0])) {
                  } else {
                    this.router.navigate(['auth/login']);
                  }
                } else if (user.user_type == 'sub-admin' && user.otp) {
                  this.data = user.addRole;
                  if (this.data.includes(type[0])) {
                  } else {
                    this.router.navigate(['auth/login']);
                  }
                } else if (user.user_type == 'student') {
                  if (this.studentTab.includes(type[0])) {
                  } else {
                    this.router.navigate(['auth/login']);
                  }
                } else {
                  this.router.navigate(['auth/login']);
                }
              })
          }
        }),
      );

  }
}
